module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("In which the mystères have their way")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Thursday, August 21, 1777.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I woke to the sound of a soft rap-rap-rap on my bedchamber door. “Who is it?” I hissed, fearful.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The door creaked open.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Father!” He was wearing a riding jacket, blue with gold buttons.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("“I’ve ordered your pony saddled,” he whispered, so as not to waken Da Gertrude. Steam was rising from the earthenware mug in his hand. It smelled of coffee and rum. “I want you to meet my new lady,” he said, tossing me a chocolate roll.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Father’s new lady was a black mare with white socks—a bold well-built girl with big eyes, young still. “Lady Luck, I’ve named her,” he said proudly, “won at the tables.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I reached out to touch her muzzle. She jerked her head away. “Sucre is small for me now,” I said. My little pony was standing by the wall with flies on her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This one’s a little hot for you,” Father said. I held the bridle as he mounted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The horses snorted as we headed down the laneway, shaking their heads against the flies. The sun had just come up; the shadows were long yet, the grass damp. A blue heron flew up as we approached the canefields, still in chaos from the harvest. On the far horizon, at the edge of the sea, the field-slaves were working, preparing a field for burning.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("“King Sugar,” Father said with an ironic smile, slapping at a mosquito. He pulled a leather flask from his coat pocket, tipped back his head.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Other planters lived like kings. Why did we have no fortune? But I knew the answer. Your father courts Lady Luck, Mother said. But the Lady mistreats him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell me a story about when you were at Court, Father.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He groaned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The hunt story?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know it by heart,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was true. I knew the story of the hunt so well I could tell it myself. How the King set out each morning with his lieutenants and under-lieutenants, the gentlemen of the chase, his squires and under-squires and pages. How the dogs howled, how the King knew each by name. How the fine-blooded horses pranced in the morning mist—so many of them sixty men were needed just to give them water!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I leaned my head on Sucre’s neck, inhaled her warm, clean scent. Imagine such a world. “A story about the Queen, then,” I said. “About the birth of the Dauphin.” About fire-rockets lighting up the night.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Father let loose his reins, allowed his mare to graze. “Speaking of queens, I was told the most extraordinary thing.” He turned to look at me. “I was told you went to see that old voodoo woman up river.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sat up. “Who told you that?” I tried not to sound alarmed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A woman in Fort-Royal.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh?” I didn’t like my father talking about me with “a woman.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s said you will be Queen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I felt my cheeks burn. I looked away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So it’s true,” he said. He held out the flask. I shook my head. “You are looking a little pale, Rose, a little thin. Have you been ill?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.” I’d been warned not to tell.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know, I wanted you to be a boy.” He took another swig from his flask. Then he laughed. “But a queen might not be so bad,” he said, urging his mare into a walk. “A queen might help pay off my gambling debts.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was punished, Father!” The words leapt from me unbidden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His saddle creaked as he turned to face me. “Punished?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tears came to my eyes.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("“For being told you will be Queen?”")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I took a shaky breath. “For talking to the Devil,” I whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The strap?” His voice cold.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I nodded. I wanted to tell him the truth, but I did not dare. I wanted to tell him about the room in the basement, about the bats and the spirits and the faces in the night. I wanted to tell him about the voices. But it would only anger him, I knew, and then there would be fights. There were fights enough.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Old Women did this?” That is what Father called Mother and Grandmother Sannois.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Father Droppet made them!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Devil be damned,” he cursed, under his breath. His mare bucked as he spurred her, bucked again as she broke into a gallop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I kicked my pony hard and held on, tears blinding me. Father cried out as I passed him at the hanging tree.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("August 25.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Catherine and I are getting ready to return to the convent school in Fort-Royal. Little Manette watches us enviously, offering to help, getting in the way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We leave day after tomorrow, in spite of the rains. The weather is hot and terribly humid. We have to push our embroidery needles through the heavy cotton cloth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("A week later, 6:00")]), _vm._v(" "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("P.M.—Fort-Royal.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Catherine and I are back at school again, back at dreary Dames de la Providence, back to Sister Gretch’s scowls. Mass at seven, classes from eight until eleven, and again from one until five. Drawing and embroidery. Reading and penmanship. Lectures on virtue and modesty. My backside is sore from sitting all day on hard benches.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("September 7.")])])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("This rainy season will never end. The streets are rivers of mud. Catherine and I are stuck here at the convent—we can’t even go to Uncle Tascher’s for Sunday supper. Instead we eat salt fish, the third evening in a row. A cockroach, the biggest I’d ever seen, was running under the tables. Catherine screamed, though I know for a fact she’s braver than most boys. She stood up on the table and stepped into at least two dinner plates and sent her own crashing to the floor. If it weren’t for Catherine, we’d die of boredom.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Wednesday, September 10, 11:00 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This morning at bath Catherine lifted her chemise when the sisters weren’t looking. I gestured to her to lower it, but she only giggled and did it again. Soon we were all being bad.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Sunday, September 14, 1:00 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("After mass this morning we were led on a promenade across the Savane. The smell of the slave ships in the harbour was strong. And then, a disturbing thing. As we turned back, Catherine whispered, “I don’t want to die!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your face is flushed,” I said, alarmed by her curious statement. “Are you ill?” She looked inflamed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tonight Catherine was the first to fall asleep. This is the most worrisome sign. Usually she gets the paddle for staying up late.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Tuesday, September 16.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Catherine is so sick now, she has to return home. I have insisted I go with her. Sister Gretch told me I am using my sister’s misfortune as an excuse not to go to school. It wouldn’t be honest, dear Diary, not to say that there is some truth in what Sister Gretch said. I hate being at the convent school, but it is also true that I am worried about Catherine. I’ve been nursing her for two days. We leave in the morning.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("September 22—Trois-Ilets.")])])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("We’ve been home five days and Catherine’s sicker still, always in a drowsy stupor. Da Gertrude has been making smelly salves to spread on her chest, but they haven’t helped. All day Mother sits and watches her, fanning her with a big palm leaf. Every so often she sponges her all over with rum, her prayers filling the rooms with a monotonous drone.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("September 23.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I found chicken feathers and bits of bone under Catherine’s bed. Voodoo magic, I hope.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("4:00 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Grandmother Sannois says Catherine has yellow fever.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yellow fever! I try not to think of Madame Laveaux’s little boy who died in the summer, try not to think what the slaves say, how Madame Laveaux pierced her dead boy’s heart with a butcher knife to keep the bokor from his grave.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Friday afternoon, September 26.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The doctor finally came and looked at Catherine. He prescribed Hoffman’s Drops with sugar. He said she’s been seized by an ague that has been succeeded by a fever, but that it’s not "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("yellow")]), _vm._v(" fever, that there’s nothing to worry about—but why is she getting worse?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I told Mother she should call the doctor back, but she said, “What’s the point? He’ll just say the same thing and charge another livre.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("September 27, 10:00 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P.M.")])])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Tonight Catherine was talking in a dream, crying out and screaming. Then she jumped out of bed and ran around the room. She thought little Manette was a giant crab trying to pinch her. Mother, Da Gertrude and I tried to hold on to her but she was strong. I couldn’t believe it, she’s so ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("thin. Finally she weakened and Da Gertrude put some herbs in a pair of socks and tied the socks onto her feet. It helped, she went to sleep.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("October 6.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Catherine gets worse. Manette and I are not allowed to go in her bed-chamber. We stand at the door, but it’s hard to see her through the nets.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Thursday, October 8.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tonight I sneaked into Catherine’s room after Mother fell asleep. I sat on her bed under the nets and we talked, whispering in the dark. Before I left I took her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mustn’t touch me,” she said, pulling away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Imagine this. Imagine that I’m holding you,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She began to cry, so I put my arms around her and held her close. How could I not?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("October 10.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Father came home late tonight. I heard him stumbling in and then I heard Mother: “Catherine is dying and where are you? Getting drunk, you damn fool!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sheet lightning lit up my room and in the dark silence I heard the shrill whistle of the fruit bats. Catherine is "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("dying?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Monday.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("After morning chores I went down to the river, looking for Mimi. I needed her help. Mimi knew the ways of the spirits, the mystères.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was up to her knees in the bathing-pool washing linens, her floursack chemise soaked. Under a lilac bush the two pugs sat watching. A chicken was scratching in the mud nearby.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It began to rain. We took shelter under a tree laden with green oranges. The pugs scuffed around at Mimi’s feet.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("“Remember when we went to the obeah woman’s hut?” I said.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You think I’d forget?” She threw a pebble at the chicken, to shoo it away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I never told you something.” I paused. The rain was coming down heavily now, dripping through the leaves. I began to feel a little ill, the way I do when a wind starts up. “The old woman told Catherine she’d be in the ground before her birthday this December. And now Mother says Catherine’s—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Catherine")]), _vm._v(" went?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When I was in the basement room.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You never told me!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("promised")]), _vm._v(" not to tell.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That girl—!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And now Mother says Catherine is . . .” I stopped, tears choking. “What if what the obeah woman said comes true?” I blurted out. “Can’t you change it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Undo it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mimi rested her chin on her knees, thinking. “A paquets Congo,” she said finally.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("“Yes,” I said, taking a breath. A paquets Congo, properly made . . .")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I spent the afternoon helping Mimi gather the ingredients: a toad (which Mimi killed, not me), a tcha-tcha root, a bag of mombin leaves and some hairs I took from Catherine’s comb.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It must be buried under a mapou tree,” Mimi said, securing the bundle with a bit of red string, the type barren women wear at voodoo ceremonies. “By moonlight.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can’t,” I said. “Not at night.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s safe if you keep your eyes down.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s Mother.” Mother doesn’t believe in voodoo, but she fears the mystères, the voodoo spirits.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll do it then,” Mimi said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Alone?” I asked, in awe of her courage.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("I don’t know how late it was when Mimi climbed in my window. “I did it,” she hissed, shaking me awake. I could hardly see her in the dark. “I buried the paquets.” Faintly, through the steady drone of the rain, I heard drums.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re wet,” I said, touching her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can’t stay.” She tightened her kerchief around her head. “There’s a séance.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I watched her climb down the mango tree, watched until I could see her no longer. I felt a chill pass through me, smelled the faint scent of a cigar. Trembling, I shut the window, pulled the drapes tight against the dark night.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("October 15.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Father Droppet came today. I must have looked suddenly pale, for he guided me to the sofa in the parlour and suggested I rest for a moment. Mother came in then. She took his soaking wet cloak and hat. “I was afraid you would not be able to make it,” she said. “The roads are so bad.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The roads are bad,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was in with Catherine for a very short time. When he came out, Mother offered him tea, but he said he must be on his way, because of the roads.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After he left I went to my bedchamber. I took the heavy wood cross down from the wall and kissed it, pressed it to my heart. Don’t take Catherine, I prayed. Don’t. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Don’t!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("October 16.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When I woke it was quiet in the house except for the sound of Mother crying and Father talking in a tired, sad voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I tiptoed into Catherine’s room and I saw her lying there, still and all alone with no one fanning her, no one praying. I watched to see her chest rise and fall, her eyelids flicker, but there was no movement, only silence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I willed myself to touch her, to wake her, but I could not. I stumbled back down the hall to my room. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Catherine is dead.")]), _vm._v(" I began to shake.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("I climbed out my window and down the mango tree. I ran up the trace to the slave shacks. Mimi was asleep on her straw pallet. She opened her eyes, seeing me slowly.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You said it would work!” I cried. I hit her with my fist.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh . . .” She grabbed my wrists, hard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do something!” I was blubbering. “Make her come back!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mimi began to cry then too. “Oh, that little brat,” she moaned. She held me in her arms and rocked me, whispering, “It’s done, it’s done, rest now.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("7:00 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The rains stopped. “We are blessed,” Mother said, her eyes shining. She washed Catherine all over with rum and laid her out in her festival gown on a patchwork counterpane. Father told me and Manette to go gather flowers. We were bringing in baskets of roses, red jasmine, orchids and honeysuckle all morning. Mother laced the orchids through Catherine’s hair and arranged the other blossoms nicely all around her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She looks beautiful,” Manette said, awed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But so still.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mother tried to get her best crucifix, the iron one with the tiny ruby in the centre, to stay in Catherine’s hands, but it kept slipping to the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That will do,” Father said. I don’t think he liked Mother fussing so.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mother laid the cross on Catherine’s chest and it stayed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the afternoon, neighbours began to arrive, gaping at our worn rugs. Later we began the journey to Trois-Ilets, two carriages and a wagon through the mud to the graveyard behind the church. The roads were perilous but it was so hot we dared not wait a day. One of the horses foundered in the deep footing and several times we had to stop to pull a carriage out of the ruts.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("The sun was going down as the box was lowered into the tomb. My knees gave way as the top was fastened on. Da Gertrude helped me to my feet. All the way home, fireflies circled us. Circled us and circled us.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("It is late now. The air is heavy with the threat of rain. I listen to the land breezes stirring the mango tree outside my window, the noisy cabri-bois. ")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Father Droppet says Catherine’s in Heaven, that she’s with God. Yet I feel her in the wind, in the dark shadows. I feel her tears and I think, Why "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Catherine?")]), _vm._v(" Why not "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("me?")]), _vm._v(" The beating of my heart such a terrible sin.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Sunday, October 19.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mother and I took a potted ginger lily to town today to put on Catherine’s tomb. Then Mother told me to go sit in the wagon. When I looked back I saw her kneeling in the dirt. I ran to see if she was hurt. She had her fist in her mouth and her face was wet. It frightened me, seeing her thus. I didn’t know what to say or do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is there a God?” she cried out. I could see rage in her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was afraid to answer, afraid that something I said might condemn Catherine to eternal Hell. “We’d better go,” I said quickly, reaching out for her, fearful of what she might do in that holy place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once home I persuaded Mother to have a rum and syrup and got her to lie down. Her cry fills me still: "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Is there a God?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My quill trembles and tiny blots of ink like a flurry of tears cover the page.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7249d7aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch03.vue
// module id = 81
// module chunks = 0